export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET!;
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID!;

// Values you may additionally want to configure globally
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-05-12';
export const filmwebProjectId = process.env.NEXT_PUBLIC_FILMWEB_SANITY_PROJECTID!;
export const movieInfoQsUrl = process.env.NEXT_PUBLIC_MOVIEINFOQS_URL!;
export const firmId = Number(process.env.NEXT_PUBLIC_FIRMID!);